import { workChecksAPI } from "./api";

export const getWorkChecksList = async (params = {}) => {
  try {
    const res = await workChecksAPI.getWorkChecksList(params);
    return res?.data;
  } catch (e) {
    // Ошибки обрабатываются централизованно в Axios interceptors
    return null;
  }
};

export const modifyWorkCheck = async (data) => {
  try {
    const res = await workChecksAPI.modifyWorkCheck(data);
    // API возвращает данные после сохранения через read()
    return res?.data;
  } catch (e) {
    // Ошибки обрабатываются централизованно в Axios interceptors
    return null;
  }
};

export const deleteWorkCheck = async (sbsWorkCheckId) => {
  try {
    const res = await workChecksAPI.deleteWorkCheck(sbsWorkCheckId);
    // API возвращает данные после удаления через read()
    return res?.data;
  } catch (e) {
    // Ошибки обрабатываются централизованно в Axios interceptors
    return null;
  }
};

export const getProjectTypes = async () => {
  try {
    const res = await workChecksAPI.getProjectTypes();
    return res?.data;
  } catch (e) {
    // Ошибки обрабатываются централизованно в Axios interceptors
    return null;
  }
};

export const getWorkSetCheckGroups = async () => {
  try {
    const res = await workChecksAPI.getWorkSetCheckGroups();
    return res?.data;
  } catch (e) {
    // Ошибки обрабатываются централизованно в Axios interceptors
    return null;
  }
};

export const getCheckLists = async () => {
  try {
    const res = await workChecksAPI.getCheckLists();
    return res?.data;
  } catch (e) {
    // Ошибки обрабатываются централизованно в Axios interceptors
    return null;
  }
};

export const getAllPlacementTypes = async () => {
  try {
    const res = await workChecksAPI.getAllPlacementTypes();
    // API может возвращать либо { data: [...] }, либо просто массив [...]
    // Проверяем структуру и возвращаем в едином формате
    if (res && typeof res === 'object' && 'data' in res) {
      return res.data;
    }
    // Если это массив, возвращаем как есть
    if (Array.isArray(res)) {
      return res;
    }
    return [];
  } catch (e) {
    // Ошибки обрабатываются централизованно в Axios interceptors
    return [];
  }
};

export const getAssignTypes = async () => {
  try {
    const res = await workChecksAPI.getAssignTypes();
    // API может возвращать либо { data: [...] }, либо просто массив [...]
    // Проверяем структуру и возвращаем в едином формате
    if (res && typeof res === 'object' && 'data' in res) {
      return res.data;
    }
    // Если это массив, возвращаем как есть
    if (Array.isArray(res)) {
      return res;
    }
    return [];
  } catch (e) {
    // Ошибки обрабатываются централизованно в Axios interceptors
    return [];
  }
};

export const workChecksTableColumns = [
  {
    name: "sbs_work_check_id",
    required: true,
    label: "ID",
    align: "center",
    field: "sbs_work_check_id",
    sortable: true,
  },
  {
    name: "project_type_name",
    required: true,
    label: "Тип проекта",
    align: "left",
    field: "project_type_name",
    sortable: true,
  },
  {
    name: "placement_type_name",
    required: true,
    label: "Тип работ",
    align: "left",
    field: "placement_type_name",
    sortable: true,
  },
  {
    name: "work_set_check_group_name",
    required: true,
    label: "Группа работ",
    align: "left",
    field: "work_set_check_group_name",
    sortable: true,
  },
  {
    name: "check_name",
    required: true,
    label: "Чек-лист",
    align: "left",
    field: "check_name",
    sortable: true,
  },
  {
    name: "assign_type_name",
    required: true,
    label: "Исполнитель",
    align: "left",
    field: "assign_type_name",
    sortable: true,
  },
  {
    name: "actions",
    label: "",
    align: "center",
    field: "actions"
  },
];

